import React, { useState, useEffect } from 'react';
import { useCreatingNewUserAtom } from '../../atoms/users/useCreatingNewUserAtom';
import { registerUser } from '../../api/authenticateAPIs';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useNotification } from '../../context/NotificationContext';
import { NotificationType } from '../../enums/NotificationType';

import TeamsMultiselect from '../../components/shared/TeamsMultiselect';
import RoleSelectBox from '../../components/shared/RoleSelectBox';
import useAuth from "../../hooks/useAuth";

import '../../css/pages/create_user.css';

const CreateUser = () => {
  const { auth } = useAuth();
  const { showNotification } = useNotification();

  const navigate = useNavigate();
  const [t] = useTranslation('global');
  const [, setCreatingNewUser] = useCreatingNewUserAtom();

  const [isLoading, setIsLoading] = useState(false);
  const [pwdMatch, setPwdMatch] = useState('');
  const [formData, setFormData] = useState({
    newUserName: '',
    lastName: '',
    email: '',
    password: '',
    confirmPassword: '',
    roleId : '',
    teamIds: []
  });

  const handleChangeEmail = (e) => {
    const { name, value } = e.target;
    let noDiacritics = value.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    setFormData({ ...formData, [name]: noDiacritics });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };


  const handleTeamChange = (event) => {
    const {
        target: { value },
    } = event;
    setFormData({
        ...formData,
        teamIds: typeof value === 'string' ? value.split(',') : value,
    });
};

  const handleGoBack = () => {
    setCreatingNewUser(false);
    navigate('/Users');
  };

  const handleConfirmPassword = () => {
    if (formData.password != formData.confirmPassword) {
      showNotification({ message: t('passwordsDontMatch'), type: NotificationType.Error });
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Submitting: ', formData);
    setIsLoading(true);

    if (formData.roleId === "") {
      showNotification({ message: t('selectRoleError'), type: NotificationType.Error });
      setIsLoading(false);
      return;
    }

    if(!formData.teamIds.length > 0) {
      showNotification({ message: t('selectTeamsRequired'), type: NotificationType.Error });
      setIsLoading(false);
      return;
    }
    registerUser(
      formData.newUserName,
      formData.lastName,
      formData.email,
      formData.password,
      formData.roleId,
      formData.teamIds
    )
    .then(() => {
      setIsLoading(false);
      showNotification({ message: t('userCreatedSuccess'), type: NotificationType.Success });
      navigate('/Users');
    })
      .catch((resp) => {
        setIsLoading(false);
        
        // let errorMessage = [];
        // for (let i = 0; i < resp.response.data.message?.length; i++) {    
        //   errorMessage += i + 1 + ". " + resp.response.data.message[i] + " ";
        // }
        showNotification({ message: resp.response.data.message, type: NotificationType.Error });
      });
  };


  useEffect(() => {
    if (auth.uri === 1) {
      return;
    } else {
      navigate('/Unauthorized');
    }
  }, []);

  return (
    <>
    {auth.uri === 1  && 
        <div className="user_form page-wrap">
          <div className="header-title">
            <h1>{t('newUser')}</h1>
          </div>
          <form onSubmit={handleSubmit} autoComplete="off" className="input-form">

            <div className="create-user-input-section">
              <div className="input-line">
                <label htmlFor="newUserName">{t('newUserName')}</label>
                <input
                  type="text"
                  id="newUserName"
                  name="newUserName"
                  value={formData.newUserName}
                  onChange={handleChange}
                  autoComplete="new-password"
                />
              </div>
              <div className="input-line">
                <label htmlFor="lastName">{t('lastName')}</label>
                <input
                  type="text"
                  id="lastName"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  autoComplete="new-password"
                />
              </div>
            </div>

            <div className="create-user-input-section">
              <div className="input-line">
                <label htmlFor="email">{t('email')}</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChangeEmail}
                  autoComplete="new-password"
                />
              </div>

              <div className='input-line'>
                <div className="selectbox-section">
                  <RoleSelectBox selectValue={formData.roleId} onChange={handleChange}/>
                </div>
             </div>
            </div>

            <div className="create-user-input-section">
              <div className="input-line">
                <label htmlFor="password">{t('password')}</label>
                <input
                  type="password"
                  id="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  autoComplete="new-password"
                />
              </div>
              <div className="input-line">
                <label htmlFor="confirm-password">{t('confirmPassword')}</label>
                <input
                  type="password"
                  id="confirm-password"
                  name="confirmPassword"
                  value={formData.confirmPassword}
                  onChange={handleChange}
                  onKeyUp={handleConfirmPassword}
                />
              </div>
              {pwdMatch.length > 0 ? 
                <div className='confirm-pwd-msg'>
                  {pwdMatch}
                </div> 
              : null }
            </div>

            <div className='input-line'>
              <div className="max-width">
                <TeamsMultiselect selectedValues={formData.teamIds} onChange={handleTeamChange}/>
              </div>
            </div> 
          </form>

          <div>
            {isLoading ? t('loading') : ''}
          </div>

            <button className="return-button" onClick={handleGoBack}>{t('return')}</button>
            <button className="submit-button" type="submit" disabled={isLoading} onClick={handleSubmit}>{t('submit')}</button>
        
        </div>}
    </>
    ); 
};

export default CreateUser;
